//carpooling
import CorImage from './assets/projects/covoiturage/1.jpeg';
import CorImage2 from './assets/projects/covoiturage/2.png';
import CorImage3 from './assets/projects/covoiturage/3.png';
import CorImage4 from './assets/projects/covoiturage/4.png';
import CorImage5 from './assets/projects/covoiturage/5.png';
import CorImage6 from './assets/projects/covoiturage/6.jpg';
import CorImage7 from './assets/projects/covoiturage/7.jpg';
import CorImage8 from './assets/projects/covoiturage/8.jpg';
import CorImage9 from './assets/projects/covoiturage/details.jpg';
import CorImage10 from './assets/projects/covoiturage/edit.jpg';
//ecommerce
import EcoImage from './assets/projects/ecommerce/1.png';
import EcoImage2 from './assets/projects/ecommerce/2.png';
import EcoImage3 from './assets/projects/ecommerce/3.png';
import EcoImage4 from './assets/projects/ecommerce/4.png';
import EcoImage5 from './assets/projects/ecommerce/5.png';
import EcoImage6 from './assets/projects/ecommerce/6.png';
//pixator
import PixaImage from './assets/projects/pixator/10.jpeg';
import PixaImage2 from './assets/projects/pixator/2.png';
import PixaImage3 from './assets/projects/pixator/3.png';
import PixaImage4 from './assets/projects/pixator/4.png';
import PixaImage5 from './assets/projects/pixator/5.png';
import PixaImage6 from './assets/projects/pixator/6.png';
//suvellecuisine
import SuvImage from './assets/projects/suvellecuisine/suvellecuisine_full.jpeg';
import SuvImage2 from './assets/projects/suvellecuisine/Screenshot_1.png';
import SuvImage3 from './assets/projects/suvellecuisine/Screenshot_2.png';
import SuvImage4 from './assets/projects/suvellecuisine/Screenshot_3.png';
//theme
import ThemeImage from './assets/projects/theme/1.jpeg';
import ThemeImage2 from './assets/projects/theme/2.jpeg';
import ThemeImage3 from './assets/projects/theme/3.png';
import ThemeImage4 from './assets/projects/theme/4.png';
import ThemeImage5 from './assets/projects/theme/5.png';
import ThemeImage6 from './assets/projects/theme/6.png';
import ThemeImage7 from './assets/projects/theme/7.png';
import ThemeImage8 from './assets/projects/theme/8.png';
import ThemeImage9 from './assets/projects/theme/9.png';
//digital menu
import MenuImage from './assets/projects/digital-menu/1.jpeg'
import MenuImage2 from './assets/projects/digital-menu/2.jpeg'
import MenuImage3 from './assets/projects/digital-menu/3.png'
import MenuImage4 from './assets/projects/digital-menu/4.png'
import MenuImage5 from './assets/projects/digital-menu/5.png'
import MenuImage6 from './assets/projects/digital-menu/6.png'
import MenuImage7 from './assets/projects/digital-menu/7.png'
//investment
import InvestmentImage from './assets/projects/investment/1.jpeg'
import InvestmentImage2 from './assets/projects/investment/2.png'
import InvestmentImage3 from './assets/projects/investment/3.png'
import InvestmentImage4 from './assets/projects/investment/4.png'

export const Projects = [
    {
        title: 'Digital Menu',
        images: [MenuImage, MenuImage2, MenuImage3, MenuImage4, MenuImage5, MenuImage6, MenuImage7],
        description: 'Our Digital Menu project is a streamlined solution for restaurants, built with React, Tailwind CSS, and Laravel. The admin can easily post and update dishes, including images, descriptions, prices, and dietary information. Customers can conveniently browse the menu, our Digital Menu modernizes the dining experience, improving customer satisfaction and operational efficiency.',
        type: "full",
        url: 'https://digital-menu-demo-zocs.onrender.com'
    },
    {
        title: 'Forex Investment Landing Page',
        images: [InvestmentImage, InvestmentImage2, InvestmentImage3, InvestmentImage4],
        description: 'Our Forex Investment Landing Page is a professionally designed platform built with React and Tailwind CSS. It provides an enticing introduction to forex investment services',
        type: 'ui',
        url: 'https://investment-p4fx.onrender.com/',
    },
    {
        title: "Carpooling - Ride-Sharing Platform",
        images: [CorImage, CorImage2, CorImage3, CorImage4, CorImage5, CorImage6, CorImage7, CorImage8, CorImage9, CorImage10],
        description: "Carpooling is a user-friendly ride-sharing platform developed with Laravel and Livewire. It allows passengers to search and select available rides while enabling motorists to easily post their available rides. With features like booking and confirmation.",
        type: "full"
    },
    {
        title: "eCommerce Website",
        images: [EcoImage, EcoImage2, EcoImage3, EcoImage4, EcoImage5, EcoImage6],
        description: "Our eCommerce website is a powerful online platform built with Laravel and AJAX. It allows administrators to effortlessly post and manage products, while providing clients with a seamless shopping experience. With features such as secure user authentication, product search and browsing, shopping cart functionality, and streamlined checkout process, our eCommerce website simplifies online shopping for customers while enabling efficient product management for administrators.",
        type: "full"
    },
    {
        title: "Pixator - Landing Page",
        images: [PixaImage, PixaImage2, PixaImage3, PixaImage4, PixaImage5, PixaImage6],
        description: " Pixator is a captivating travel agency landing page developed using React and TailwindCSS.",
        type: "ui"
    },
    {
        title: "Suvellecuisine Portfolio",
        images: [SuvImage, SuvImage2, SuvImage3, SuvImage4],
        description: "Suvellecuisine Portfolio is a captivating showcase of culinary creations that I redesigned using React and TailwindCSS.",
        type: "ui"
    },
    {
        title: "Theme Selection Website",
        images: [ThemeImage, ThemeImage2, ThemeImage3, ThemeImage4, ThemeImage5, ThemeImage6, ThemeImage7, ThemeImage8, ThemeImage9],
        description: "Our theme selection website, built with Django and TailwindCSS, facilitates the process of choosing themes for students' master's or bachelor's final projects. Professors propose a variety of themes, and students have the opportunity to browse and select their preferred themes. The responsible professor then assigns each theme to a student based on their qualifications and preferences. With its intuitive interface, secure authentication, theme proposal management, and streamlined theme selection process, our website simplifies and automates the theme selection workflow, ensuring an efficient and fair allocation of themes to students.",
        type: "full",
    },
];